module.exports = __webpack_public_path__ + "media/src/images/favicons/apple-touch-icon-114x114-7c83b91197aedd47a576d8ed22da5def.png";